import {Component, inject, input} from '@angular/core';
import {MatDividerModule} from "@angular/material/divider";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatListModule} from "@angular/material/list";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {ClickEventService} from '../../../../utils/services/click-event.service';

@Component({
  selector: 'app-documentation-sidenav',
  imports: [
    MatIconModule,
    RouterLink,
    MatDividerModule,
    MatButtonModule,
    MatListModule,
    RouterLinkActive
  ],
  templateUrl: './documentation-sidenav.component.html',
  styleUrl: './documentation-sidenav.component.scss'
})
export class DocumentationSidenavComponent {
  readonly isMobile = input.required<boolean>();
  private readonly clickEventService: ClickEventService = inject(ClickEventService);

  onNavigate() {
    if (this.isMobile()) {
      this.clickEventService.emitClickSideNavEvent();
    }
  }
}
